<template>
  <section class="case-creation" v-loading="loading">
    <div class="container-sm">
      <!-- ! Patient Information || Case Creation -->
      <div class="case-creation__step case-creation__patient-information pt-15">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-patient-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Patient Information</h3>
            </div>
          </div>
          <PatientInformation
            v-if="showDob"
            :patientInfo="patientInformation"
            ref="patientInformationForm"
          >
          </PatientInformation>
        </div>
      </div>

      <span class="case-creation__divider"></span>
      <!-- ! Case Information || Case Creation -->
      <div class="case-creation__step case-creation__patient-information">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-case-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Case Information</h3>
                </div>
              </div>
              <div class="case-creation__body pb-0">
                <div class="vue-form">
                  <div
                    style="display: flex; gap: 12px; font-family: sans-serif"
                  >
                    <div>
                      <p style="margin: 0; font-weight: 500">STAT Case</p>
                    </div>
                    <div>
                      <label
                        style="
                          position: relative;
                          display: inline-block;
                          width: 50px;
                          height: 28px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="caseInformation.is_stat"
                          style="opacity: 0; width: 0; height: 0"
                        />
                        <span
                          :style="`
                        position: absolute;
                        cursor: pointer;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: 20px;
                        width: 36px;
                        background-color: ${
                          caseInformation.is_stat ? '#4ade80' : '#f2f2f2'
                        };
                        border : ${
                          caseInformation.is_stat ? '#4ade80' : '#f2f2f2'
                        };
                        border-radius: 34px;
                        transition: 0.4s;
                        display: flex;
                        align-items: center;
                        padding: 0 4px;
                      `"
                        >
                          <span
                            :style="`
                          height: 20px;
                          width: 20px;
                          background-color: ${
                            caseInformation.is_stat ? '#f2f2f2' : 'white'
                          };
                          border-radius: 50%;
                          transition: 0.4s;
                          transform: translateX(${
                            caseInformation.is_stat ? '22px' : '0'
                          });
                        `"
                          ></span>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div style="margin-bottom: 20px">
                    <small style="height: 12px; opacity: 50%"
                      >(only for emergency cases)</small
                    >
                  </div>
                  <el-form :model="caseInformation">
                    <el-row :gutter="15">
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <el-form-item>
                          <div class="case-creation__input">
                            <label for="text">
                              Case Type
                              <span class="star">*</span>
                            </label>
                            <el-select
                              multiple
                              filterable
                              v-model="caseInformation.case_types"
                              placeholder="Select Case Type"
                              collapse-tags
                              :multiple-limit="getCaseTypeLimit"
                              disabled
                            >
                              <el-option
                                v-for="(caseType, index) of getCaseTypes"
                                :key="index"
                                :value="caseType.value"
                                :label="caseType.case_name"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="case_types"></FormError>
                            </p>
                            <div
                              class="case-select-types"
                              :class="{
                                'active-case-type-error': isError,
                              }"
                            >
                              <p
                                class="selected-case-types"
                                v-for="(
                                  caseTypeVal, index
                                ) in caseInformation.case_types"
                                :key="index"
                              >
                                {{ caseTypeMap[caseTypeVal] || caseTypeVal }}
                              </p>
                            </div>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Laboratory
                              <span class="star">*</span>
                            </label>
                            <el-select
                              placeholder="Select Laboratory"
                              v-model="caseInformation.received_lab"
                              filterable
                              default-first-option
                              @focus="fetchAllSendoutLabs"
                            >
                              <el-option
                                v-for="(lab, index) of getAllLabs"
                                :key="index"
                                :value="lab._id"
                                :label="lab.name"
                                :disabled="
                                  getCaseInformation &&
                                  getCaseInformation.lab &&
                                  getCaseInformation.lab._id == lab._id
                                    ? true
                                    : false
                                "
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="received_lab"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Collection Date & Time
                              <span class="star">*</span>
                            </label>

                            <el-date-picker
                              type="datetime"
                              v-model="caseInformation.collection_date"
                              placeholder="MM-DD-YYYY HH:MM AM"
                              format="MM-DD-YYYY hh:mm A"
                              :disabled-date="disabledDate"
                            ></el-date-picker>
                            <p class="err">
                              <FormError
                                errorName="collection_date"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Received Date & Time
                              <span class="star">*</span>
                            </label>
                            <el-date-picker
                              type="datetime"
                              v-model="caseInformation.received_date"
                              placeholder="MM-DD-YYYY HH:MM AM"
                              format="MM-DD-YYYY hh:mm A"
                              :disabled-date="disabledDate"
                            ></el-date-picker>

                            <p class="err">
                              <FormError errorName="received_date"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Ordering Facility
                              <span class="star">*</span>
                            </label>
                            <el-select
                              v-model="caseInformation.hospital"
                              placeholder="Select Ordering Facility"
                              @change="fetchAllPhysiciansByHospital"
                              clearable
                              filterable
                              default-first-option
                              @focus="fetchAllHospitals"
                              :loading="hospitalsLoading"
                            >
                              <el-option
                                v-for="(hospital, index) of hospitalsData.data"
                                :key="index"
                                :value="hospital._id"
                                :label="hospital.name"
                                :disabled="isInactiveStatus(hospital)"
                              >
                                <span style="float: left">{{
                                  hospital.name
                                }}</span>
                                <span
                                  v-if="isInactiveStatus(hospital)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 10px;
                                  "
                                >
                                  Inactive
                                </span>
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="hospital"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Ordering Facility Branch</label>
                            <el-select
                              placeholder="Select Ordering Facility Branch"
                              @change="fetchAllPhysiciansByHospitalBranch"
                              v-model="caseInformation.hospital_branch"
                              default-first-option
                              :reserve-keyword="false"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="(hospital, index) of hospitalBranches"
                                :key="index"
                                :value="hospital._id"
                                :label="hospital.display_name"
                                :disabled="isInactiveStatus(hospital)"
                              >
                                <span style="float: left">
                                  {{ hospital.display_name }}
                                </span>
                                <span
                                  v-if="isInactiveStatus(hospital)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 10px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="facility_branch"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Ordering Physician
                              <span class="star">*</span>
                            </label>
                            <el-select
                              placeholder="Select Ordering Physician"
                              v-model="caseInformation.ordering_physician"
                              filterable
                              default-first-option
                            >
                              <el-option
                                v-for="physician in physiciansData.data"
                                :key="physician._id"
                                :label="physician.name"
                                :value="physician._id"
                                :disabled="isInactiveStatus(physician)"
                              >
                                <span style="float: left">{{
                                  physician.name
                                }}</span>
                                <span
                                  v-if="isInactiveStatus(physician)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 15px;
                                  "
                                >
                                  Inactive
                                </span>
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="ordering_physician"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Referring Physician</label>
                            <el-select
                              v-model="caseInformation.referring_physician"
                              placeholder="Select Referring Physician"
                              clearable
                              filterable
                              default-first-option
                              :reserve-keyword="false"
                              @focus="fetchRefferingPhysicians"
                              :loading="physicianLoading"
                            >
                              <el-option
                                v-for="physician in allReferringPhysicians"
                                :key="physician._id"
                                :label="physician.name"
                                :value="physician._id"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="referring_physician"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Bill To
                              <span class="star">*</span>
                            </label>
                            <el-select
                              placeholder="Select Bill To"
                              clearable
                              filterable
                              default-first-option
                              v-model="caseInformation.billing_type"
                            >
                              <el-option
                                class="referring-physician-options"
                                label="INSURANCE"
                                value="INSURANCE"
                              ></el-option>
                              <el-option
                                label="PATIENT"
                                value="PATIENT"
                              ></el-option>
                              <el-option
                                label="CLIENT"
                                value="CLIENT"
                              ></el-option>
                              <el-option
                                label="LABCORP"
                                value="LABCORP"
                              ></el-option>
                              <!-- <el-option
                                label="SENDOUT"
                                value="SENDOUT"
                              ></el-option> -->
                            </el-select>
                            <p class="err">
                              <FormError errorName="billing_type"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Order Id</label>
                            <el-input
                              type="text"
                              placeholder="Enter Order Id"
                              v-model="caseInformation.requisition_order_id"
                              :rows="3"
                            ></el-input>
                            <p class="err">
                              <FormError
                                errorName="requisition_order_id"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Specimen Collector</label>
                            <el-input
                              placeholder="Enter Specimen Collector"
                              v-model="caseInformation.specimen_collector"
                            ></el-input>
                            <p class="err">
                              <FormError
                                errorName="specimen_collector"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="16" :lg="16" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                column-gap: 2rem;
                              "
                            >
                              <label for="text">
                                ICD-10 ( Indicative )
                                <span class="star">*</span>
                              </label>
                              <el-checkbox
                                class="el-checkbox-icd"
                                style="
                                  display: flex;
                                  align-items: center;
                                  height: 14px;
                                "
                                v-model="includeAllICDCodes"
                                >Include All ICD Codes</el-checkbox
                              >
                            </div>

                            <div class="ten-icd-group d-flex">
                              <div
                                class="each-input mr-5"
                                v-for="(
                                  icdCode, index
                                ) of caseInformation.icd_10_codesForm"
                                :key="index"
                              >
                                <el-autocomplete
                                  placeholder="CODE"
                                  v-model="icdCode.value"
                                  popper-class="ten-icd-popper"
                                  :fetch-suggestions="getAutoCompleteICDData"
                                  @select="selectICDCode($event, icdCode)"
                                >
                                  <template #default="{ item }">
                                    <div class="icd-dropdown-style">
                                      <span class="code pr-5">
                                        {{ item.code }}
                                      </span>
                                      <span class="desc pl-5">
                                        {{ item.description }}
                                      </span>
                                    </div>
                                  </template>
                                </el-autocomplete>
                              </div>
                            </div>
                            <p class="err">
                              <FormError errorName="icd_10_codes"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col
                        :xl="8"
                        :lg="12"
                        :md="3"
                        :sm="6"
                        :xs="6"
                        v-if="
                          caseInformation.case_types &&
                          caseInformation.case_types.length
                        "
                      >
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text"
                              >Specimen Types <span class="star">*</span></label
                            >
                            <div
                              class="specimen-case-type"
                              v-for="(type, index) in this.caseInformation
                                .sample_types"
                              :key="index"
                            >
                              <span class="case-name">{{
                                caseTypeMap[type.case_type]
                              }}</span>
                              <span class="custom-select-capitalize">
                                <el-select
                                  disabled
                                  v-model="type.sample_types"
                                  multiple
                                  filterable
                                  allow-create
                                  :reserve-keyword="false"
                                  default-first-option
                                  @focus="fetchSpecimenTypes"
                                  popper-class="custom-select-dropdown"
                                >
                                  <el-option
                                    v-for="(
                                      specimen, index
                                    ) in getAllSampleTypes"
                                    :key="index"
                                    :label="specimen.sample_type.toLowerCase()"
                                    :value="specimen.sample_type"
                                  ></el-option>
                                </el-select>
                                <p class="err">
                                  <FormError
                                    :errorName="`sample_types.${index}.sample_types`"
                                  ></FormError>
                                </p>
                              </span>
                            </div>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col
                        :xl="3"
                        :lg="3"
                        :md="3"
                        :sm="6"
                        :xs="6"
                        v-if="hadBloodCaseType"
                      >
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text"
                              >Fasting
                              <span class="star">*</span>
                            </label>
                            <el-select
                              v-model="caseInformation.is_fasting"
                              clearable
                              disabled
                            >
                              <el-option
                                v-for="item in fastingOptions"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label"
                              >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="is_fasting"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <span class="case-creation__divider"></span>
      <!-- ! Test Information || Case Creation -->
      <div class="case-creation__step case-creation__test-information">
        <div class="case-creation__card">
          <div class="text-information-card">
            <div class="case-creation__heading border-bottom-none">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-test-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Test Information</h3>
              </div>
            </div>
            <div class="test-information-header">
              <p>You can manage tests here, please add to start</p>
            </div>
          </div>
        </div>
        <div class="center-error-message" v-if="isTestInfoError">
          <p class="err">
            <FormError errorName="tests_info"></FormError>
          </p>
        </div>
      </div>
      <div
        class="selected-tests-information"
        v-if="
          (panelsTestsData.selectedCategories &&
            panelsTestsData.selectedCategories.length > 0) ||
          (panelsTestsData.selectedGroup &&
            panelsTestsData.selectedGroup.length > 0 &&
            !addtestModelPopup &&
            !hideTestsDetails)
        "
      >
        <div class="each-test-information">
          <el-checkbox-group
            v-model="panelsTestsData.selectedTestIds"
            class="case-vue-tabs vue-tabs"
          >
            <el-tabs v-if="!addtestModelPopup">
              <el-tab-pane
                v-for="(test, index) of getSelectedCaseTypes()"
                :key="index"
                :class="test"
              >
                <template #label>
                  <h3 class="selected-test-title">
                    {{ caseTypeMap[test.case_type_code] }}
                  </h3>
                </template>
                <div v-if="test.case_type_code == 'TOXICOLOGY'">
                  <ToxicologyTestsPreview
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                    :removeSelection="false"
                  ></ToxicologyTestsPreview>
                </div>
                <div v-else-if="test.case_type_code == 'WOUND'">
                  <WoundPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                    :removeSelection="false"
                  ></WoundPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'NAIL'">
                  <NailPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></NailPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'GASTRO'">
                  <GastroPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></GastroPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'UTI'">
                  <UTIPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                    :removeSelection="false"
                  ></UTIPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'URINE_CULTURE'">
                  <UrineCulturePanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                    :removeSelection="false"
                  ></UrineCulturePanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'CLINICAL_CHEMISTRY'">
                  <BloodPanelSelectedTests
                    :panelTestsData="panelsTestsData"
                    :test="test"
                    :allSelectedTests="allTests"
                    :removeSelection="false"
                  ></BloodPanelSelectedTests>
                </div>
                <div v-else-if="test.case_type_code == 'STI'">
                  <GTIWomensHealthTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></GTIWomensHealthTests>
                </div>
                <div v-else-if="test.case_type_code == 'URINALYSIS'">
                  <UrinalysisTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></UrinalysisTestsPreview>
                </div>
                <div
                  v-else-if="
                    test.case_type_code == 'RESPIRATORY_PATHOGEN_PANEL'
                  "
                >
                  <RespiratoryTestsPreview
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></RespiratoryTestsPreview>
                </div>
                <div v-else-if="test.case_type_code == 'WOMENS_HEALTH'">
                  <WomensHealthSelectedTests
                    :panelTestsData="panelsTestsData"
                    :newCase="checkCaseValidation"
                    :test="test"
                    :allSelectedTests="allTests"
                  ></WomensHealthSelectedTests>
                </div>
                <div v-else>
                  <DefaultPanelSelectedTests
                    v-if="show"
                    :panelTestsData="panelsTestsData"
                    :testType="test"
                    :allSelectedTests="allTests"
                    :caseType="test.case_type_code"
                    :removeSelection="false"
                  >
                  </DefaultPanelSelectedTests>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-checkbox-group>
        </div>
      </div>
      <span class="case-creation__divider"></span>

      <div v-if="isCaseHavingAdditionalNotes">
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-billing-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Additional Notes</h3>
            </div>
          </div>
          <div class="case-creation__body padding-0">
            <div class="billing-information-tabs-view">
              <el-row :gutter="30">
                <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Additional Notes</h4>
                    <p
                      class="value"
                      v-if="
                        (this.getSendOutInformation &&
                          this.getSendOutInformation.physician_notes) ||
                        (this.getCaseInformation &&
                          this.getCaseInformation.physician_notes)
                      "
                    >
                      {{
                        this.getSendOutInformation.physician_notes ||
                        this.getCaseInformation.physician_notes
                      }}
                    </p>
                    <p class="value" v-else>--</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <div class="case-creation__step case-creation__test-information">
        <BillingInformation
          :billingInfo="billingInfoToUse"
        ></BillingInformation>
      </div>
      <span class="case-creation__divider"></span>
      <!-- Medications start here -->
      <div class="case-creation__step case-creation__test-information">
        <MedicationsAdd
          v-if="showMedication"
          ref="medicationFormDetails"
          :newCase="checkCaseValidation"
          :medicationsData="medicationsList"
        ></MedicationsAdd>
        <div class="center-error-message" v-if="isMedicationError">
          <p class="err">
            <FormError errorName="medication"></FormError>
          </p>
        </div>
      </div>

      <!-- Medications end here -->
      <div>
        <p
          class="err"
          v-if="
            getSendOutInformationValidationErrors &&
            getSendOutInformationValidationErrors.critical_error
          "
        >
          <FormError errorName="critical_error"> </FormError>
        </p>
      </div>

      <!-- Action buttons -->
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>
      <span class="case-creation__divider"></span>

      <div class="case-creation__actions fixed">
        <ul class="list">
          <li>
            <button
              type="button"
              class="btn cancel-button"
              @click="goToAllCases"
            >
              Cancel
            </button>
          </li>
          <li v-if="this.$route.params.sendout_id">
            <button
              type="button"
              class="btn save-button"
              @click="createNewSendOut"
              v-loading="loading"
            >
              Update
            </button>
          </li>
          <li v-else>
            <button
              type="button"
              class="btn save-button"
              @click="createNewSendOut"
              v-loading="loading"
            >
              Save
            </button>
          </li>
        </ul>
      </div>
    </div>
    <ExistingCaseDetails
      v-if="errorDiloag"
      :existedCase="existedCaseDetails"
      :caseType="caseInformation.case_types"
      :caseInformation="caseInformationDetails"
      :case="caseUpdate"
      :newCase="newCase"
      v-on:closeDialog="handleClose"
      v-on:closePopupDialog="handlePopUp"
      @newCaseCreation="newCaseCreation"
      @approveCase="approveCase"
    >
    </ExistingCaseDetails>

    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="updateCase"
    >
    </ResonForChange>
    <div class="default-modal" v-if="showBillingInfoPopup">
      <el-dialog
        v-model="showBillingInfoPopup"
        width="35%"
        :before-close="handleCloseBilling"
      >
        <div class="export-dialog-header">
          <div class="export-header-part pl-1r">
            <h3>Kindly choose the insurance you want to send</h3>
          </div>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="handleCloseBilling"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date pb-0">
          <div class="reorder-radio">
            <el-radio-group
              v-model="selectedBillingType"
              class="re-order-radio-list"
            >
              <el-radio label="CLIENT">CLIENT</el-radio>
              <el-radio label="INSURANCE">INSURANCE</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="dialog-footer w-95">
          <el-button
            class="blue-save-button"
            :disabled="checkOptions"
            @click="addCase()"
            >Save</el-button
          >
        </div>
      </el-dialog>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";
import AppHelper from "@/mixins/AppHelper";
import caseConstants from "@/config/constants/caseConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
import BillingInformation from "@/components/sendOuts/BillingInformation.vue";
const WoundPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WoundPanelSelectedTests"
  )
);
const UTIPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UTIPanelSelectedTests"
  )
);
const UrineCulturePanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/UrineCulturePanelSelectedTests"
  )
);
const BloodPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/BloodPanelSelectedTests"
  )
);
const ToxicologyTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/ToxicologyTestsPreview")
);
const DefaultPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/DefaultPanelSelectedTests"
  )
);
const NailPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/NailPanelSelectedTests"
  )
);
const GastroPanelSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GastroPanelSelectedTests"
  )
);
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import { startLoading } from "@/helpers/loadingHelper";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const ExistingCaseDetails = defineAsyncComponent(() =>
  import("@/components/cases/ExisistedCaseInfo")
);
import PatientInformation from "@/components/sendOuts/PatientInformationAdd";
import MedicationsAdd from "@/components/sendOuts/MedicationsAdd";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const GTIWomensHealthTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/GTIWomensHealthTests"
  )
);
const UrinalysisTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/UrinalysisTestsPreview")
);
const RespiratoryTestsPreview = defineAsyncComponent(() =>
  import("@/components/panels/testsPreview/RespiratoryTestsPreview")
);
const WomensHealthSelectedTests = defineAsyncComponent(() =>
  import(
    "@/components/cases/testInfo/selectedTestsPreview/WomensHealthSelectedTests"
  )
);
export default {
  components: {
    ExistingCaseDetails,
    ResonForChange,
    FormError,
    WoundPanelSelectedTests,
    UTIPanelSelectedTests,
    UrineCulturePanelSelectedTests,
    ToxicologyTestsPreview,
    BloodPanelSelectedTests,
    DefaultPanelSelectedTests,
    PatientInformation,
    MedicationsAdd,
    NailPanelSelectedTests,
    GastroPanelSelectedTests,
    GTIWomensHealthTests,
    UrinalysisTestsPreview,
    RespiratoryTestsPreview,
    BillingInformation,
    WomensHealthSelectedTests,
  },
  mixins: [caseDataHelper, AppHelper, UserPermissionsHelper],
  data() {
    return {
      usersList: [],
      page: 1,
      pageSize: 10,
      errorDiloag: false,
      caseUpdate: false,
      newCase: false,
      existedCaseDetails: {},
      caseInformationDetails: {},
      hideTestsDetails: false,
      filterString: "",
      takeReasonDialog: false,
      buttonLoading: false,
      loading: false,
      formData: {
        drug: "",
        group: "",
        is_child: true,
      },
      patientMedicationFormData: {
        options: [],
        medications: [],
        medicationsData: [],
        groupOptions: [],
        value: "",
        list: [],
        loading: false,
      },
      medicationLoading: false,
      addMedicationModelPopup: false,
      modalLoading: false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      faxInputValue: "",
      sendOutId: "",
      accessionId: "",
      caseId: "",
      defaultTime: [new Date(2000, 2, 1, 10, 0, 0)],
      //case information
      caseInformation: {
        is_stat: false,
        case_types: [],
        received_lab: "",
        collection_date: "",
        specimen_collector: "",
        received_date: "",
        hospital: "",
        hospital_branch: "",
        ordering_physician: "",
        referring_physician: null,
        icd_10_codes: "",
        billing_type: "",
        requisition_order_id: "",
        icd_10_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
        ],
        is_fasting: "",
      },
      fastingOptions: caseConstants.FASTING,
      search_case_types: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      selectedTab: null,
      show: false,
      showDob: false,
      showPatientDob: false,
      showMedication: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },

      allTests: [],
      primaryInsuranceForm: {},
      showPatientState: false,
      hospitalsData: {},
      physiciansData: {},
      patientInformation: {},
      hospitalsLoading: false,
      physicianLoading: false,
      hospitalBranches: [],
      allReferringPhysicians: [],
      medicationsList: [],
      includeAllICDCodes: false,
      showBillingInfoPopup: false,
      selectedBillingType: "",
    };
  },
  computed: {
    checkCaseValidation() {
      if (this.$route.query.case_id || this.$route.params.sendout_id) {
        return false;
      }
      return true;
    },
    ...mapGetters("sendOuts", [
      "getSendOutInformation",
      "getSendOutInformationSaveStatus",
      "getSendOutInformationValidationErrors",
      "getSendOutPatientInformationValidationErrors",
      "getSingleSendoutTestsInfo",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("cases", [
      "getCaseInformation",
      "getMedicationCreateStatus",
      "getMedicationValidationErrors",
      "getAllMedications",
      "getStateAndCity",
      "getSingleCaseTestsInfo",
    ]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("branches", ["getAllBranches"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("labs", ["getAllLabs"]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    getCaseTypeLimit() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length &&
        this.caseInformation.case_types.indexOf("COVID_FLU") != -1
      ) {
        return 1;
      }
      return 1;
    },
    getCaseTypes() {
      return this.search_case_types;
    },
    isError() {
      if (
        this.getErrors &&
        this.getErrors.received_lab &&
        this.caseInformation.case_types.length > 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    hadBloodCaseType() {
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
      ) {
        return true;
      }
      return false;
    },
    isCaseHavingAdditionalNotes() {
      if (
        (this.getSendOutInformation &&
          this.getSendOutInformation.physician_notes) ||
        (this.getCaseInformation && this.getCaseInformation.physician_notes)
      ) {
        return true;
      }
      return false;
    },
    checkOptions() {
      if (this.selectedBillingType) {
        return false;
      }
      return true;
    },
    ...mapGetters("orders", {
      orderCaseInformation: "getCaseInformation",
    }),
    ...mapGetters("emrOrders", ["getSingleEMROrder"]),
    billingInfoToUse() {
      // If sendout_id exists, use getSendOutInformation, else use getCaseInformation
      return this.$route.query.sendout_id || this.$route.params.sendout_id
        ? this.getSendOutInformation.billing_info
        : this.getCaseInformation.billing_info;
    },
  },
  async mounted() {
    await this.loadInitData();
    // Add Class
    this.toggleBodyClass("addClass", "fixedNavbarBody");
  },
  async unmounted() {
    // Remove Class
    this.toggleBodyClass("removeClass", "fixedNavbarBody");
  },
  methods: {
    async handleCloseBilling() {
      this.showBillingInfoPopup = false;
      this.selectedBillingType = "";
    },
    async fetchAllSendoutLabs() {
      await this.$store.dispatch("labs/fetchAllLabs", {
        get_all: true,
        for_sendout: true,
      });
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      try {
        this.caseInformation.ordering_physician = undefined;

        if (hospitalBranch) {
          let params = {
            hospital_branch: hospitalBranch,
            get_all: true,
          };
          await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        } else {
          this.fetchAllPhysiciansByHospital(this.caseInformation.hospital);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchRefferingPhysicians() {
      this.physicianLoading = true;
      await this.$store.dispatch("physicians/fetchAllPhysicians", {
        get_all: true,
      });

      this.allReferringPhysicians =
        this.getAllPhysicians &&
        this.getAllPhysicians.data &&
        this.getAllPhysicians.data.length
          ? this.getAllPhysicians.data
          : [];
      this.physicianLoading = false;
    },
    async toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    async remove(index) {
      this.caseInformation.case_types.splice(index, 1);
      if (
        this.caseInformation &&
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length == 0
      ) {
        this.patientMedicationFormData.options = [];
      }
    },
    async loadInitData() {
      const loading = startLoading();
      try {
        await this.$store.commit("errors/clear");
        await this.$store.commit(
          "sendOuts/setSendOutInformationValidationErrors",
          {}
        );
        if (this.$route.query.case_id) {
          await this.checkCaseInformation();
          this.caseForm = true;
          this.show = true;
        } else if (this.$route.params.sendout_id) {
          this.checkSendOutCaseInformation();
          this.show = true;
        } else {
          this.loading = false;
          this.caseForm = true;
        }
        let params = { get_all: true };
        await this.$store.dispatch("help/fetchAllStates");
        await this.$store.dispatch("labs/fetchAllLabs", params);
        this.showDob = true;
        this.showPatientDob = true;
        this.showPatientState = true;
        this.showMedication = true;
        await this.getLabCaseTypes();
        loading.close();
      } catch (err) {
        loading.close();
      }
    },
    async fetchAllHospitals() {
      this.hospitalsLoading = true;
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalsLoading = false;
    },
    updateSendout() {
      this.takeReasonDialog = true;
    },
    prepreDataFromFormData() {
      let patientFormInfo = this.$refs["patientInformationForm"];
      let params = this.parseCaseInfo();

      let patientInfo = patientFormInfo.formatPatientInfo();

      params.patient_info = this.getFormattedValues(patientInfo);

      const selectedTestIds = (this.panelsTestsData.selectedTestIds || []).map(
        (id) => (id && typeof id == "object" ? id._id : id)
      );
      params.tests_info = Array.from(new Set(selectedTestIds.filter(Boolean)));

      const groupedPanels = (this.panelsTestsData.selectedGroup || []).flatMap(
        (group) =>
          (group.panel_ids || []).map((panelId) => ({
            panel_id: panelId,
            case_type_code: group.case_type_code,
            all_tests: true,
            test_ids: [],
          }))
      );

      const mergedPanels = [
        ...(this.panelsTestsData.selectedCategories || []),
        ...groupedPanels,
      ];
      params.panels = Object.values(
        mergedPanels.reduce((acc, panel) => {
          const panelId = panel && panel.panel_id && typeof panel.panel_id == "object"
            ? panel.panel_id._id
            : panel.panel_id;
          const key = `${panelId}|${panel.case_type_code}`;
          if (!acc[key]) {
            acc[key] = {
              panel_id: panelId,
              case_type_code: panel.case_type_code,
              all_tests: true,
              test_ids: panel.test_ids || [],
            };
          }
          return acc;
        }, {})
      );

      let medicationFormDetails = this.$refs["medicationFormDetails"];
      if (medicationFormDetails) {
        params.medication = medicationFormDetails.getMedicationsList();
      }
      if (this.hadBloodCaseType && this.caseInformation.is_fasting) {
        params.is_fasting = this.caseInformation.is_fasting;
      }
      if (
        (this.getCaseInformation && this.getCaseInformation.physician_notes) ||
        (this.getSendOutInformation &&
          this.getSendOutInformation.physician_notes)
      ) {
        params.physician_notes =
          this.getCaseInformation.physician_notes ||
          this.getSendOutInformation.physician_notes;
      }
      if (
        this.caseInformation.case_types?.some((type) =>
          [
            "UTI",
            "WOUND",
            "URINE_CULTURE",
            "NAIL",
            "GASTRO",
            "RESPIRATORY_PATHOGEN_PANEL",
            "URINALYSIS",
            "STI",
            "WOMENS_HEALTH",
            "ENT",
          ].includes(type)
        )
      ) {
        params.groups = this.panelsTestsData.selectedGroup;
      }

      return params;
    },
    parseCaseInfo() {
      return {
        case_types: this.caseInformation.case_types,
        received_lab: this.caseInformation.received_lab,
        collection_date: this.convertToLabUTC(
          this.caseInformation.collection_date
        ),
        received_date: this.convertToLabUTC(this.caseInformation.received_date),
        hospital: this.caseInformation.hospital,
        icd_10_codes: this.caseInformation.icd_10_codesForm
          .filter((e) => e.value)
          .map((e) => e.value),
        ordering_physician: this.caseInformation.ordering_physician,
        referring_physician: this.caseInformation.referring_physician,
        billing_type: this.caseInformation.billing_type,
        patient_info: this.caseInformation.patient_info,
        is_stat: this.caseInformation.is_stat,
        accession_id: this.accessionId,
        case_id: this.$route.params.sendout_id ? undefined : this.caseId,
        specimen_collector: this.caseInformation.specimen_collector
          ? this.caseInformation.specimen_collector
          : undefined,
        sample_types: this.convertSampleTypesToCapital(
          this.caseInformation.sample_types
        ),
      };
    },
    convertSampleTypesToCapital(sampleTypes) {
      if (!sampleTypes) return "";
      return sampleTypes.map((s) => {
        s.sample_types = s.sample_types.map((f) => this.changetocaptila(f));
        return s;
      });
    },
    async handleClose(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });

      window.location.reload();
    },
    async handlePopUp(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });
    },
    async newCaseCreation(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      window.location.reload();
    },
    async approveCase(response) {
      try {
        this.errorDiloag = response;
        await this.$store.commit("errors/clear");
        this.loading = true;
        let params = this.prepreDataFromFormData();
        params.auto_approved = true;
        await this.$store.dispatch("cases/addNewCase", params);
        if (this.getCaseCreationStatus) {
          successNotification("New Case Created Successfully");
          this.goBack();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification("Error while creating New Case");
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    async createNewSendOut() {
      const sendOutId = this.$route.params.sendout_id;
      if (sendOutId) {
        this.askReason();
      } else {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.billing_info &&
          this.getCaseInformation.billing_info.insurance &&
          this.getCaseInformation.billing_info.insurance.primary_insurance
        ) {
          this.showBillingInfoPopup = true;
        } else {
          await this.addCase();
        }
      }
    },
    async updateCase(reason) {
      try {
        this.loading = true;
        let params = this.prepreDataFromFormData();
        const sendOutId = this.$route.params.sendout_id;
        params.send_out_id = sendOutId;
        params.data_update_reason = reason;
        await this.$store.dispatch("sendOuts/updateSendOut", params);
        this.caseUpdate = true;
        if (this.getSendOutInformationSaveStatus) {
          successNotification("Sendout Updated Successfully");
          this.goToAllCases();
        } else if (this.getSendOutInformationValidationErrors) {
          this.scrollToFirstError();
        } else {
          if (!this.getSendOutInformationValidationErrors) {
            errorNotification("Error while updating Case");
          }
        }
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async addCase() {
      try {
        this.showBillingInfoPopup = false;
        this.loading = true;
        let params = this.prepreDataFromFormData();
        if (
          this.selectedBillingType &&
          this.selectedBillingType == "INSURANCE"
        ) {
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.primary_insurance
          ) {
            let primaryInsurance = {
              ...this.getCaseInformation.billing_info.insurance
                .primary_insurance,
            };
            if (primaryInsurance) {
              if (
                primaryInsurance?.insurance_carrier_code === "SMAL0" ||
                primaryInsurance?.insurance_carrier_code === "SMTX0"
              ) {
                primaryInsurance.insurance_carrier_code = "SMDC0";
              }

              params.billing_info = {
                ...params.billing_info,
                insurance: {
                  primary_insurance: primaryInsurance,
                },
              };
            }
          }
          params.billing_type = "INSURANCE";
        } else {
          params.billing_type = "CLIENT";
        }
        await this.$store.dispatch("sendOuts/createNewSendOut", params);
        this.loading = false;
        if (this.getSendOutInformationSaveStatus) {
          successNotification("Send Out Created Successfully");
          this.goToAllCases();
        } else {
          if (!this.getSendOutInformationValidationErrors) {
            errorNotification("Error while Creating New Send Out");
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    goToAllCases() {
      if (this.$route.query.case_id) {
        this.$route.query.case_id = undefined;
      }
      this.$router.push({
        name: "allSendOuts",
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("err")[0];

      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    async fetchAllPhysiciansByHospital(hospital) {
      try {
        this.caseInformation.ordering_physician = undefined;
        this.caseInformation.hospital_branch = null;
        let params = {
          hospital,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        await this.$store.dispatch("branches/fetchAllBranches", {
          hospital_id: hospital,
        });
        this.hospitalBranches = this.getAllBranches.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getAutoCompleteICDData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_string = searchString.trim();
        }
        if (
          this.caseInformation.case_types &&
          this.caseInformation.case_types.length &&
          this.includeAllICDCodes == false
        ) {
          params.primary_case_types = this.caseInformation.case_types[0];
        }
        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        const allIcdCodes = [];
        (this.getAllIcd10Codes.data || []).forEach((el) => {
          allIcdCodes.push({
            value: el.code + " - " + el.description,
            ...el,
          });
        });

        cb(allIcdCodes || []);
      } catch (err) {
        return cb([]);
      }
    },
    selectICDCode(event, icdCodeData) {
      icdCodeData.value = event.code;
      this.previousSearchString = "";
    },
    getLabCaseTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.search_case_types = this.getUserBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },
    updateTestsPanelsData(event) {
      this.show = false;
      this.modalLoading = true;
      const loading = startLoading();

      if (event && event.data) {
        this.panelsTestsData.selectedTestIds = event.data.selectedTestIds;
        this.panelsTestsData.selectedCategories = event.data.selectedCategories;
        this.panelsTestsData.selectedGroup = event.data.selectedGroup;
        this.allTests = event.allTests;
      }
      setTimeout(() => {
        this.show = true;
        loading.close();
      }, 500);
    },
    getSelectedCaseTypes() {
      if (
        this.caseInformation.case_types &&
        this.caseInformation.case_types.length
      ) {
        const caseTypes = this.caseInformation.case_types;
        const filteredCategories =
          this.panelsTestsData.selectedCategories.filter((category) =>
            caseTypes.includes(category.case_type_code)
          );
        const filteredGroups = this.panelsTestsData.selectedGroup.filter(
          (group) => caseTypes.includes(group.case_type_code)
        );
        let data = [...filteredCategories, ...filteredGroups];
        const uniqueData = this.getSelectedCaseTypesGlobal(data);
        return uniqueData;
      } else {
        this.allTests = [];
        this.panelsTestsData.selectedTestIds = [];
        this.panelsTestsData.selectedCategories = [];
        this.panelsTestsData.selectedGroup = [];
      }
      return [];
    },
    async checkCaseInformation() {
      try {
        this.loading = true;
        this.caseId = this.$route.query.case_id;

        await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
        if (!this.getCaseInformation) {
          this.disablePatientInformation = true;
        }
        await this.fetchAllHospitals();
        if (this.getCaseInformation && this.getCaseInformation.hospital) {
          await this.fetchAllPhysiciansByHospital(
            this.getCaseInformation.hospital._id
          );
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.referring_physician
        ) {
          await this.fetchRefferingPhysicians();
        }
        if (this.getCaseInformation) {
          if (this.getCaseInformation.patient_info) {
            this.patientInformation = {
              ...this.getCaseInformation.patient_info,
            };
          }
        }
        this.setCaseInformationData();
        if (this.getCaseInformation && this.getCaseInformation.sample_types) {
          this.caseInformation.sample_types =
            this.getCaseInformation.sample_types;
        }
        if (
          this.getCaseInformation.medication &&
          this.getCaseInformation.medication.length != 0
        ) {
          this.medicationsList = this.getCaseInformation.medication.medication;
        }
        if (this.getCaseInformation && this.getCaseInformation.is_fasting) {
          this.caseInformation.is_fasting = this.getCaseInformation.is_fasting;
        }
        await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
          lab_id: this.getCaseInformation.lab._id,
          case_type_code: this.getCaseInformation.case_types[0],
        });

        await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
          lab_id: this.getCaseInformation.lab._id,
          case_type_code: this.getCaseInformation.case_types[0],
        });

        await this.$store.dispatch(
          "cases/fetchCaseTestsInfo",
          this.$route.query.case_id
        );
        if (this.getSingleCaseTestsInfo) {
          this.panelsTestsData.selectedTestIds =
            this.getSingleCaseTestsInfo.map((el) => el._id);
          let casePanelsTestsInfo = this.getSingleCaseTestsInfo.filter(
            (test) => !test.group_id
          );
          let caseGroupsTestsInfo = this.getSingleCaseTestsInfo.filter(
            (test) => test.group_id
          );

          const transformedPanels = Object.values(
            casePanelsTestsInfo.reduce((acc, test) => {
              const key = `${test.panel_id}|${test.case_type_code}`;
              if (!acc[key]) {
                acc[key] = {
                  panel_id: test.panel_id,
                  case_type_code: test.case_type_code,
                  all_tests: true,
                  test_ids: [],
                };
              }
              acc[key].test_ids.push(test._id);
              return acc;
            }, {})
          );
          this.panelsTestsData.selectedCategories = transformedPanels;

          const uniqueGroups = Object.values(
            caseGroupsTestsInfo.reduce((acc, test) => {
              if (!acc[test.group_id]) {
                acc[test.group_id] = {
                  group_id: test.group_id,
                  group_code: test.group_code,
                  group_title: test.group_title,
                  case_type_code: test.case_type_code,
                };
              }
              return acc;
            }, {})
          );
          this.panelsTestsData.selectedGroup = uniqueGroups.map((e) => {
            e._id = e.group_id;
            e.panel_ids = Array.from(
              new Set(
                this.getSingleCaseTestsInfo
                  .filter((test) => test.group_id == e.group_id)
                  .map((test) => test.panel_id)
              )
            );
            e.case_type_code = e.case_type_code;
            return e;
          });

          // Populate selectedCategories from group panel_ids so DefaultPanelSelectedTests
          // can render group-based types (e.g. ENT) without a dedicated component.
          this.panelsTestsData.selectedGroup.forEach((group) => {
            (group.panel_ids || []).forEach((panelId) => {
              if (
                !this.panelsTestsData.selectedCategories.find(
                  (c) => c.panel_id === panelId && c.case_type_code === group.case_type_code
                )
              ) {
                this.panelsTestsData.selectedCategories.push({
                  panel_id: panelId,
                  case_type_code: group.case_type_code,
                  all_tests: true,
                  test_ids: this.getSingleCaseTestsInfo
                    .filter((t) => t.panel_id === panelId)
                    .map((t) => t._id),
                });
              }
            });
          });
        }
        this.allTests = this.getSingleCaseTestsInfo;
        this.caseInformation.is_stat = this.getCaseInformation.is_stat;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    setCaseInformationData() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation) &&
        Object.keys(this.getCaseInformation).length
      ) {
        this.caseInformation.case_types = this.getCaseInformation.case_types;

        this.caseInformation.collection_date = this.convertLabUTCToClient(
          this.getCaseInformation.collection_date
        );
        this.caseInformation.received_date = this.convertLabUTCToClient(
          this.getCaseInformation.received_date
        );
        this.caseInformation.hospital = this.getCaseInformation.hospital
          ? this.getCaseInformation.hospital._id
          : null;
        const casePhysician = this.getCaseInformation.ordering_physician;
        if (casePhysician) {
          const physicians = this.physiciansData?.data || [];
          const matched = physicians.find(p => casePhysician.npi_code && p.npi_code === casePhysician.npi_code)
            || physicians.find(p => p._id === casePhysician._id);
          this.caseInformation.ordering_physician = matched?._id || casePhysician._id || null;
        } else {
          this.caseInformation.ordering_physician = null;
        }
        this.caseInformation.referring_physician =
          this.getCaseInformation.referring_physician &&
          this.getCaseInformation.referring_physician._id
            ? this.getCaseInformation.referring_physician._id
            : null;
        this.caseInformation.hospital_branch = this.getCaseInformation
          .hospital_branch
          ? this.getCaseInformation.hospital_branch._id
          : null;
        this.caseInformation.icd_10_codes =
          this.getCaseInformation.icd_10_codes;

        this.caseInformation.billing_type =
          this.getCaseInformation.billing_type;

        this.caseInformation.requisition_order_id =
          this.getCaseInformation.requisition_order_id || "";
        this.caseInformation.specimen_collector =
          this.getCaseInformation.specimen_collector;
        this.caseInformation.patient_info =
          this.getCaseInformation.patient_info;
        this.accessionId = this.getCaseInformation.accession_id;
        if (!this.caseInformation.icd_10_codesForm) {
          this.caseInformation.icd_10_codesForm = [];
        }
        this.caseInformation.icd_10_codes.forEach((el, index) => {
          if (!this.caseInformation.icd_10_codesForm[index]) {
            this.caseInformation.icd_10_codesForm[index] = { sno: index + 1, value: '' };
          }
          this.caseInformation.icd_10_codesForm[index].value = el;
        });
        this.caseInformation.additional_fax =
          this.getCaseInformation.additional_fax &&
          this.getCaseInformation.additional_fax.length
            ? this.getCaseInformation.additional_fax
            : [];
      }
    },

    async checkSendOutCaseInformation() {
      try {
        this.loading = true;
        this.sendOutId = this.$route.params.sendout_id;
        await this.$store.dispatch("sendOuts/fetchSendOutInformation", {
          send_out_id: this.sendOutId,
        });

        await this.fetchAllHospitals();
        if (this.getSendOutInformation && this.getSendOutInformation.hospital) {
          await this.fetchAllPhysiciansByHospital(
            this.getSendOutInformation.hospital._id
          );
        }
        if (!this.getSendOutInformation) {
          this.disablePatientInformation = true;
        }

        if (this.getSendOutInformation) {
          if (this.getSendOutInformation.patient_info) {
            this.patientInformation = {
              ...this.getSendOutInformation.patient_info,
            };
          }
          this.setSendOutCaseInformationData();
          if (
            this.getSendOutInformation &&
            this.getSendOutInformation.sample_types
          ) {
            this.caseInformation.sample_types =
              this.getSendOutInformation.sample_types;
          }
          if (
            this.getSendOutInformation.medication &&
            this.getSendOutInformation.medication.length != 0
          ) {
            this.medicationsList =
              this.getSendOutInformation.medication.medication;
          }
          if (
            this.getSendOutInformation &&
            this.getSendOutInformation.is_fasting
          ) {
            this.caseInformation.is_fasting =
              this.getSendOutInformation.is_fasting;
          }

          await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
            lab_id: this.getSendOutInformation.lab._id,
            case_type_code: this.getSendOutInformation.case_types[0],
          });

          await this.$store.dispatch("labTests/fetchLabPanelsWiseTests", {
            lab_id: this.getSendOutInformation.lab._id,
            case_type_code: this.getSendOutInformation.case_types[0],
          });

          await this.$store.dispatch(
            "sendOuts/fetchSendoutTestsInfo",
            this.$route.params.sendout_id
          );

          if (this.getSingleSendoutTestsInfo) {
            this.panelsTestsData.selectedTestIds =
              this.getSingleSendoutTestsInfo.map((el) => el._id);
            const transformed = Object.values(
              this.getSingleSendoutTestsInfo.reduce((acc, test) => {
                const key = `${test.panel_id}|${test.case_type_code}`;
                if (!acc[key]) {
                  acc[key] = {
                    panel_id: test.panel_id,
                    case_type_code: test.case_type_code,
                    all_tests: true,
                    test_ids: [],
                  };
                }
                acc[key].test_ids.push(test._id);
                return acc;
              }, {})
            );
            this.panelsTestsData.selectedCategories = transformed;
            const uniqueGroups = Object.values(
              this.getSingleSendoutTestsInfo.reduce((acc, test) => {
                if (!acc[test.group_id]) {
                  acc[test.group_id] = {
                    group_id: test.group_id,
                    group_code: test.group_code,
                    group_title: test.group_title,
                    case_type_code: test.case_type_code,
                  };
                }
                return acc;
              }, {})
            );

            this.panelsTestsData.selectedGroup = uniqueGroups.map((e) => {
              e._id = e.group_id;
              e.panel_ids = Array.from(
                new Set(
                  this.getSingleSendoutTestsInfo
                    .filter((test) => test.group_id == e.group_id)
                    .map((test) => test.panel_id)
                )
              );
              return e;
            });
          }

          this.allTests = this.getSingleSendoutTestsInfo;
          this.loading = false;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    setSendOutCaseInformationData() {
      if (
        this.getSendOutInformation &&
        Object.keys(this.getSendOutInformation) &&
        Object.keys(this.getSendOutInformation).length
      ) {
        this.caseInformation.case_types = this.getSendOutInformation.case_types;
        this.caseInformation.received_lab =
          this.getSendOutInformation.received_lab._id;
        this.caseInformation.ordering_date =
          this.getSendOutInformation.ordering_date;
        this.caseInformation.collection_date = this.convertLabUTCToClient(
          this.getSendOutInformation.collection_date
        );
        this.caseInformation.received_date = this.convertLabUTCToClient(
          this.getSendOutInformation.received_date
        );
        this.caseInformation.hospital = this.getSendOutInformation.hospital
          ? this.getSendOutInformation.hospital._id
          : null;
        const sendOutPhysician = this.getSendOutInformation.ordering_physician;
        if (sendOutPhysician) {
          const physicians = this.physiciansData?.data || [];
          const matched = physicians.find(p => sendOutPhysician.npi_code && p.npi_code === sendOutPhysician.npi_code)
            || physicians.find(p => p._id === sendOutPhysician._id);
          this.caseInformation.ordering_physician = matched?._id || sendOutPhysician._id || null;
        } else {
          this.caseInformation.ordering_physician = null;
        }
        this.caseInformation.referring_physician =
          this.getSendOutInformation.referring_physician &&
          this.getSendOutInformation.referring_physician._id
            ? this.getSendOutInformation.referring_physician._id
            : null;
        this.caseInformation.hospital_branch = this.getSendOutInformation
          .hospital_branch
          ? this.getSendOutInformation.hospital_branch._id
          : null;
        this.caseInformation.icd_10_codes =
          this.getSendOutInformation.icd_10_codes;

        this.caseInformation.billing_type =
          this.getSendOutInformation.billing_type;
        this.caseInformation.requisition_order_id =
          this.getSendOutInformation.requisition_order_id || "";
        this.caseInformation.specimen_collector =
          this.getSendOutInformation.specimen_collector;
        this.caseInformation.patient_info =
          this.getSendOutInformation.patient_info;
        if (!this.caseInformation.icd_10_codesForm) {
          this.caseInformation.icd_10_codesForm = [];
        }  
        this.caseInformation.icd_10_codes.forEach((el, index) => {
          if (!this.caseInformation.icd_10_codesForm[index]) {
            this.caseInformation.icd_10_codesForm[index] = { sno: index + 1, value: '' };
          }
          this.caseInformation.icd_10_codesForm[index].value = el;
        });
        this.accessionId = this.getSendOutInformation.accession_id;
        this.caseInformation.additional_fax =
          this.getSendOutInformation.additional_fax &&
          this.getSendOutInformation.additional_fax.length
            ? this.getSendOutInformation.additional_fax
            : [];
      }
    },
  },
  watch: {
    "caseInformation.case_types": {
      immediate: true,
      handler: function () {
        this.hideTestsDetails = true;
        setTimeout(() => {
          this.hideTestsDetails = false;
        }, 1000);
      },
    },
  },
};
</script>

<style lang="scss">
//test-information start
.vue-form {
  .mobile-icon {
    position: relative;

    .el-icon {
      position: absolute;
      right: 2%;
      top: 38%;
      opacity: 0.3;
    }
  }
}

.case-creation__card {
  &.sendout {
    margin-bottom: 5px;
  }
}

.empty-test-inner {
  margin-top: 5em;
  margin-bottom: 5em;
  text-align: center;

  .test-info {
    margin: 0 auto;

    img {
      width: 115px;
      margin: 10px;
    }
  }

  .content {
    text-align: center;

    p {
      color: #828282;
      line-height: 22px;
      font-size: 14px;
    }

    .el-button {
      margin: 14px 0;

      background: #0a5da6 !important;
      box-shadow: 0px 8px 16px -4px rgba(16, 38, 137, 0.1);
      border-radius: 10px;
      color: #fff;
      border: 0.7px solid #0a5da6;
    }
  }
}

// test information end

// test reports start
.case-creation__heading {
  &.sendouts-test {
    display: grid;
    grid-template-columns: 200px 300px;
    align-items: center;
    gap: 120px;
  }
}

.test-reports-sendouts {
  .repots-sendouts {
    .el-switch {
      margin: 0px 11px;

      .el-switch__core {
        width: 30px !important;
        height: 14px;
        background: rgba(10, 93, 166, 0.3);

        .el-switch__action {
          height: 8px;
          width: 8px;
          top: 1.8px;
        }
      }
    }

    .el-switch.is-checked .el-switch__core .el-switch__action {
      left: 33px !important;
    }
  }
}

.test-tabs {
  padding: 0;

  .el-upload {
    width: 100%;
  }

  .el-tabs__active-bar {
    background-color: #0a5da6;
    border-radius: 25px;

    height: 3px;
  }

  .el-tabs__item.is-active {
    color: #0a5da6;
    font-weight: 600;
  }

  .el-tabs__item:hover {
    color: #0a5da6;
    font-weight: 600;
  }

  .types {
    .case-type {
      &.view-reports-dialog {
        .el-button {
          border: 1px dashed #bababc;
          min-height: 30px;
          padding: 0 34px;
          background-color: #f2f6f9;
          width: 100%;

          span {
            display: flex;
            align-items: center;
            justify-content: center;

            p {
              color: #333333;
              font-weight: 400;
            }

            img {
              margin-right: 6px;
            }
          }
        }
      }

      .el-input__inner {
        border: 1px solid #56ccf2cc;
        height: 30px;
      }
    }

    .btn {
      margin-top: 22px;

      .el-button {
        color: #fff;
        padding: 8px 24px;
        min-height: 30px;
        border-radius: 7px;
        background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%);
      }
    }
  }
}

.active-case-type-error {
  margin-top: 25px !important;
}

// test reports ends

//Look popup start
.case-creation__footer {
  .el-dialog__header {
    padding: 0;

    .icon {
      display: none;
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog {
    border-radius: 10px;
    min-height: 590px;
  }
}

.history {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .patient-history {
    display: inline-flex;
    align-items: center;
    background: #f24a55;
    min-width: 133px;
    max-width: 100%;
    border-radius: 7px;
    padding: 5px 10px 5px 10px;
    color: #fff;

    .title {
      color: #ffffff;
      font-weight: 500;
      font-size: 14px;
      text-align: center;
      text-transform: uppercase;
    }
  }

  .cancel-icon {
    .el-white {
      padding: 0;
      min-height: 30px;
      border: none;

      img {
        margin-right: 8px;
        margin-top: -5px;
        position: relative;
        top: 6px;
        width: 30px;
        height: 23px;
      }
    }
  }
}

.popup-details {
  padding: 18px 18px 0 18px;
  border-bottom: 1px solid #e7e7f7;
}

.history-details {
  padding: 18px 18px 0 18px;

  .history-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      color: #34495e;
      font-size: 13px;
      text-transform: capitalize;
    }

    .el-button {
      background-color: #eb5757;
      border-radius: 5px;
      min-height: 32px;
      padding: 0px 11px;

      h4 {
        color: #fff;
        text-transform: uppercase;
      }
    }
  }

  .history-heading {
    background-color: #0a5da6;
    border-radius: 5px;
    padding: 2px 5px;
    margin-top: 6px;
    color: #fff;
    font-size: 14px;

    h3 {
      font-size: 14px;
    }
  }

  h1 {
    text-align: center;
    color: #34495e;
    font-weight: 600;
    font-size: 16px;
    padding-top: 10px;
  }

  .popup-btn {
    display: flex;
    justify-content: flex-end;
    margin: 0 18px 0px;

    .el-button {
      min-height: 25px;
      background-color: #0a5da6;
      color: #fff;
      padding: 7px 9px;
      border-radius: 5px;
    }

    .blue-cancel-button {
      background-color: #eb5757;
      color: #fff;
      border-radius: 5px;
    }
  }
}

.history-table {
  padding: 0 18px 18px 18px;

  .el-table thead {
    color: rgba(0, 0, 0, 0.8);
    font-size: 12.5px;
  }

  .el-table__row {
    color: #34495e;
    font-weight: 500;
    font-size: 13px;
  }

  .el-table {
    .el-table__cell {
      padding: 0;
    }
  }

  .el-table__header-wrapper {
    .el-table__header {
      min-height: 30px;
      border-radius: 3px;
      overflow: hidden;
      border: 1px solid #dddddd;

      td.el-table__cell,
      th.el-table__cell.is-leaf {
        border-bottom: none;
      }
    }
  }
}

.popup-btn {
  display: flex;
  justify-content: flex-end;
  margin: 0 18px 0px;

  .el-button {
    min-height: 25px;
    background-color: #0a5da6;
    color: #fff;
    padding: 7px 9px;
    border-radius: 5px;
  }

  .blue-cancel-button {
    background-color: #eb5757;
    color: #fff;
    border-radius: 5px;
  }
}

//Look popup ends
</style>
